// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header-view{position:fixed;top:0;height:2.8125rem;z-index:100;background:red;font-family:Arial,Helvetica,\"sans-serif\"}.header-view .van-nav-bar{height:2.8125rem;line-height:2.8125rem;font-size:1.5rem;font-weight:900;color:#000}.header-view .van-nav-bar .van-nav-bar__title{font-size:1.125rem;font-weight:900;color:#000}.header-view .van-nav-bar .van-icon{font-size:1.5rem;font-weight:900;color:#000}", ""]);
// Exports
module.exports = exports;
